'use client';

import Image from 'next/image';
import { tv } from 'tailwind-variants';
import Autoplay from 'embla-carousel-autoplay';
import { useRef } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Testimonial } from '@/app/(main)/(pages)/_types/testimonial.type';
import { Card } from '@/components/ui/card.component';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { DotsVariantEnum } from '@/components/ui/carousel-dot-button.component';

const testimonialsCarouselStyles = tv({
  slots: {
    item: ['flex justify-start flex-col w-75 pl-0'],
    carouselContent: [
      'pl-6 mr-6 gap-4 -ml-0',
    ],
  },
});

interface TestimonialSectionCardsMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  testimonials: Testimonial[];
}

export const TestimonialSectionCardsMobile = ({ testimonials, className }: TestimonialSectionCardsMobileProps) => {
  const plugin = useRef(Autoplay({ delay: 4000, stopOnInteraction: true }));
  const { item, carouselContent } = testimonialsCarouselStyles();

  return (
    <div className={className}>
      <Carousel
        plugins={[plugin.current]}
        onMouseEnter={plugin.current.stop}
        onMouseLeave={plugin.current.reset}
        orientation="horizontal"
        opts={{ loop: false }}
        data-testid={DataTestIdEnum.TESTIMONIAL_CARROUSEL}
        showDots
        hideDotsWhenCantScroll
        dotsColorVariant={DotsVariantEnum.GREEN}
      >
        <CarouselContent className={carouselContent()}>
          {testimonials.map((testimonial) => (
            <CarouselItem
              key={testimonial.id}
              className={item()}
            >
              <Card className="relative p-5 h-[19rem] rounded-2xl">
                <div className="flex justify-center">
                  <div className="overflow-hidden flex-shrink-0 rounded-lg border border-gray-200 mb-4">
                    <Image
                      src={testimonial.image}
                      alt={`Foto de ${testimonial.name}`}
                      className="w-[5.5rem] h-[5.5rem] object-cover"
                    />
                  </div>
                </div>

                <Typography className="break-words text-gray-800 mb-4">
                  "
                  {testimonial.message}
                  "
                </Typography>
                <Typography className="absolute bottom-5 break-words font-bold">
                  {testimonial.name}
                </Typography>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
};
